// extracted by mini-css-extract-plugin
export var callSection = "webinarseat-module--callSection--57e47";
export var callSectionWrap = "webinarseat-module--callSectionWrap--608f3";
export var quoteImage = "webinarseat-module--quoteImage--1efe1";